<span class="deal-deposit-status {{statusClass}}" id='deal-deposit-status'>{{statusText}}</span>
